import { NavToggle, nextFocusableElement } from '../../../mu-2022/src/scripts/inc/nav-toggle';


var observer = new IntersectionObserver( function ( entries ) {
    if ( entries[ 0 ].boundingClientRect.y < 0 ) {
        document.body.classList.add( "scrolled" );
    } else {
        document.body.classList.remove( "scrolled" );
    }
} );
observer.observe( document.querySelector( "#pixel-to-watch" ) );



// convert any sub menu items into a button
const globallinks = document.querySelectorAll( '.header-nav .menu-item-has-children > a' );
	
globallinks.forEach( ( item ) => {
    // convert the a tags into buttons
    let b = document.createElement( 'button' );
    b.classList.value = item.classList.value;
    b.innerHTML = item.innerHTML;
    b.addEventListener('click', (e) => {
        e.preventDefault() 
    });
    item.after( b );
    item.remove();

} );	

// enable JS interactions on the global nav
let globaNavLiEl = document.querySelectorAll( '.header-nav > ul > li' );
globaNavLiEl.forEach( ( item ) => {
	if (item.querySelector('button') != null) {
		item.navToggle = new NavToggle( item );
	}
} );



// enable the global menu to open and close
let mobileNav = document.querySelector( '.header-nav' );
let mobileNavOpen = document.getElementById( 'headerMobileBTN' );

let globalNavToggle = new NavToggle( {
	'el': mobileNav,
	'button': mobileNavOpen,
} );



// Small helper to calculate the real viewport height. 
var viewport = window.visualViewport;
function setvh() {
    let vh = 0;
    if ( viewport ) {
        vh = viewport.height * 0.01;
    } else {
        vh = window.innerHeight * 0.01;
    }
    document.documentElement.style.setProperty( '--vh', `${ vh }px` );
}
if ( viewport ) {
    window.visualViewport.addEventListener( 'resize', setvh ); // for newer browsers
} else {
    window.addEventListener( 'resize', setvh );
}
setvh();
